export const mountingPositionMap = {
  IN_LINE: 'In line',
  CROSS_LINE: 'Cross line',
  STEM_EXTENSION: 'With stem extension',
  NO_STEM_EXTENSION: 'Without stem extension',
  WITHOUT_SPEED_CONTROL_BLOCKS: 'Without speed control block',
  WITH_SPEED_CONTROL_BLOCKS: 'With speed control block',
};

export const sapProductionText = {
  info: 'Samenstellen en functioneel testen',
  mountingPosition: 'Montage: ',
};
